export const inviteFields = [['location', 'Location'], ['department', 'Department'], ['division', 'Division'],
  ['jobTitle', 'Payroll Job Title'], ['payGroup', 'Pay Type'], ['workerType', 'Employee Type'], ['state', 'State']];

// Retain team annotations only, never the workforce census. Server identity
// matching supplies memberId; names and client-side email guesses are not authority.
export async function loadWorkforceInviteFilters(api: any, companyId: string, teamId: string, current: () => boolean): Promise<{
  members: Map<string, Record<string, string[]>>; filters: Array<[string, string[]]>;
}> {
  const context = await api.getWorkforceBrowseContext(companyId);
  if (!current() || context.scope?.companyId !== companyId || context.mode !== 'snapshot' || context.availability !== 'ready' || !context.snapshot?.id) throw new Error('Employee data changed. Reopen Send/Edit Emails.');
  const snapshotId = context.snapshot.id, members = new Map<string, Record<string, string[]>>();
  let after = '0', membershipBaseline: string | undefined;
  const seen = new Set<string>();
  for (;;) {
    if (!current() || seen.has(after)) throw new Error('Employee data changed. Reopen Send/Edit Emails.');
    seen.add(after);
    const page = await api.getWorkforceRosterPage(companyId, {snapshotId, teamId, after, ...(membershipBaseline ? {membershipBaseline} : {})});
    if (!current() || page.companyId !== companyId || page.teamId !== teamId || page.snapshotId !== snapshotId
      || !page.membershipBaseline || membershipBaseline && membershipBaseline !== page.membershipBaseline) throw new Error('Team members changed. Reopen Send/Edit Emails.');
    membershipBaseline = page.membershipBaseline;
    for (const row of page.employees) {
      const values = members.get(row.memberId) || {};
      for (const [field, label] of inviteFields) {
        const value = String(row[field] || '').trim();
        if (value) values[label] = [...new Set([...(values[label] || []), value])];
      }
      members.set(row.memberId, values);
    }
    if (!page.next) break;
    after = page.next;
  }
  const filters: Array<[string, string[]]> = inviteFields.map(([, label]) => [label,
    [...new Set([...members.values()].flatMap(value => value[label] || []))].sort((a, b) => a.localeCompare(b))]);
  return {members, filters: filters.filter(([, values]) => values.length > 0)};
}
